import { useContext, useEffect, useReducer, useState } from "react";
import { Store } from "../Store";
import { getError } from "../utils";
import useAxios from "./useAxios";

const reducer = (state, action) => {
  switch (action.type) {
    case "FETCH_REQUEST":
      return { ...state, loading: true };
    case "FETCH_SUCCESS":
      return {
        ...state,
        loading: false,
      };
    case "FETCH_FAIL":
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default function useTableUsers() {
  const axios = useAxios();
  const { dispatch: ctxDispatch, state } = useContext(Store);
  const { tableUsers, userInfo } = state;
  const [{ loading, error }, dispatch] = useReducer(reducer, {
    loading: false,
    error: "",
  });

  const [loadTableUsers, setLoadTableUsers] = useState(false);

  const fetchTableUsers = async () => {
    try {
      dispatch({ type: "FETCH_REQUEST", payload: {} });
      const { data } = await axios.get(`/api/tableusers`);

      dispatch({ type: "FETCH_SUCCESS", payload: data });
      ctxDispatch({
        type: "TABLE_USERS_UPDATED",
        payload: data || [],
      });
    } catch (err) {
      dispatch({ type: "FETCH_FAIL", payload: getError(err) });
    }
  };

  useEffect(() => {
    if (userInfo && !tableUsers) {
      fetchTableUsers();
    }
  }, [userInfo]);

  useEffect(() => {
    if (loadTableUsers) {
      fetchTableUsers();
      setLoadTableUsers(false);
    }
  }, [loadTableUsers]);

  return [loading, error, setLoadTableUsers];
}
